import { Injectable } from '@angular/core';
//import $ = require("jquery");

@Injectable({
  providedIn: 'root'
})
export class CommonUtilService {

  constructor() { }

  DisplayAndHideSideMenu(screenName:string)
  {
    let screenURL= screenName;//window.location.href;
    //alert(screenURL);
    if(screenURL.indexOf('receipt-authentication')!=-1)
    {
      $("#ancReceiptAuthentication").removeClass("nav-link");
      $("#ancReceiptAuthentication").addClass("sidemenu_click");

      $("#ancDownloadAuthentication,#ancDownloadLarge").removeClass("sidemenu_click");
      $("#ancDownloadAuthentication,#ancDownloadLarge").addClass("nav-link");

      $("#ancDownloadAuthentication").css("display","none");
      $("#ancReceiptAuthentication,#ancDownloadLarge").css("display","block");

    }
    else if(screenURL.indexOf('download-authenticated-receipt')!=-1) 
    {
      $("#ancDownloadAuthentication").removeClass("nav-link");
      $("#ancDownloadAuthentication").addClass("sidemenu_click");
      $("#ancDownloadAuthentication").css("display","none");

      $("#ancReceiptAuthentication,#ancDownloadLarge").removeClass("sidemenu_click");
      $("#ancReceiptAuthentication,#ancDownloadLarge").addClass("nav-link");

      // $("#ancReceiptAuthentication,#ancDownloadLarge").css("display","none");
      //$("#ancDownloadAuthentication").css("display","block");
      

    }
    else if(screenURL.indexOf('receipts/retrieve')!=-1)
    {
      $("#ancDownloadLarge").removeClass("nav-link");
      $("#ancDownloadLarge").addClass("sidemenu_click");

      $("#ancReceiptAuthentication,#ancDownloadAuthentication").removeClass("sidemenu_click");
      $("#ancReceiptAuthentication,#ancDownloadAuthentication").addClass("nav-link");

      $("#ancDownloadAuthentication").css("display","none");
      $("#ancReceiptAuthentication,#ancDownloadLarge").css("display","block");

    }
  
  }

  public GetBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
}

public IsMobileDevice():boolean
{
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    return true;
  else
    return false;
  

}

showSpinner()
  {
    
      $("#idSpinner").css("display","block");
     
    
  }

  hideSpinner()
  {
    
      $("#idSpinner").css("display","none");
      
    
  }

  checkTimer:any;
         setCookie (cname) {
            // start timer to wait for cookie
            this.checkTimer = window.setInterval(function () {

                if (document.cookie.indexOf(cname) !== -1) {
                    // hide spinner
                    
                    $('#divDownloading').fadeOut(4000);
                    window.clearTimeout(this.checkTimer);
                    document.cookie = encodeURIComponent(cname) + "=deleted; expires=" + new Date(0).toUTCString();
                    
                }
            }, 100);
        };

         expireCookie(cName) {
            document.cookie =
                encodeURIComponent(cName) + "=deleted; expires=" + new Date(0).toUTCString();
        }

        hideDownloadIcon()
        {
          $('#divDownloading').fadeOut('slow');
        }

}


